<template>
  <v-card class="wrapper table-wrapper d-flex flex-column pa-3 ma-0 gap-1">
    <AppBar
      @get-items="handleGetItems"
      @open-dialog="handleDialog"
      @open-dialog-severance="handleDialogSeverance"
      @saleryOperation-options="handleSaleryOptions"
      @update_value="handleVal"
      :salery-options="saleryOptions"
      :validate="validate"
      :isDisabled="isDisabled"
      :be-selected="beSelected"
    />
    <Table
      :loading="loading"
      :save-return="saveReturn"
      :salery-operations-options="saleryOperationsOptions"
      @appBarObject="handleQuery"
      @isDisabled="handleDisable"
      @table-changing="handleGetFormula"
      @again-ready-to-save="handleSave"
      @validation="handleValidation"
      @at-least-one-required="handleMostBeSelected"
      @open-calc-dialog="handleCalcDialog"
      @show-error="handleShowError"
    />
    <AddEid
      :open-dialog="openDialog"
      @close-dialog="handleCloseDialog"
      :salery-operations-options="saleryOperationsOptions"
    />
    <AddSeverance
      :open-dialog="openDialogSeveranc"
      @close-dialog="handleCloseDialog"
      :salery-operations-options="saleryOperationsOptions"
    />
    <CalcDialog
      :calc="calc"
      :row-data="rowData"
      :year="calcYear"
      :month="calcMonth"
      @close="handleClose"
    />
    <ActionSection
      style="max-height: 80px; overflow-y: auto; flex-shrink: 0"
      class="mt-4"
      :formula="Formula"
      :loader="loading"
      @loading="handleLoading"
      @click-save-and-return="handleSaveAndReturn"
    />
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = false">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import AppBar from "@/views/dashboard/pages/payroll/saleryOperations/partial/AppBar.vue";
import Table from "@/views/dashboard/pages/payroll/saleryOperations/partial/Table.vue";
import ActionSection from "@/views/dashboard/pages/payroll/saleryOperations/partial/ActionSection.vue";
import AddEid from "./partial/AddEid.vue";
import AddSeverance from "./partial/AddSeverance.vue";
import CalcDialog from "./partial/details/CalcDialog.vue";

export default {
  name: "saleryOperationList",
  components: {
    AppBar,
    Table,
    AddEid,
    AddSeverance,
    ActionSection,
    CalcDialog,
  },
  data: () => ({
    refresh: false,
    openDialog: false,
    openDialogSeveranc: false,
    initialLoading: true,
    saveReturn: false,
    items: null,
    Formula: null,
    loading: false,
    validate: true,
    beSelected: false,
    showTable: false,
    saleryOperationsOptions: [],
    saleryOptions: [],
    rowData: [],
    isDisabled: false,
    calc: false,
    snakbar: false,
    snakbarText: null,
    snakbarColor: "pink",
  }),
  watch: {},
  mounted() {},
  methods: {
    handleShowError(message) {
      if (!message) return;
      this.snakbarText = message;
      this.snakbarColor = "pink";
      this.snakbar = true;
    },
    handleVal() {
      this.beSelected = false;
      this.validate = true;
    },
    handleMostBeSelected() {
      this.beSelected = true;
    },
    handleValidation(val) {
      this.validate = false;
    },
    handleSaleryOptions(val) {
      this.saleryOperationsOptions = val;
    },
    handleQuery(val) {
      this.saleryOptions = val;
    },
    handleDisable(val) {
      this.isDisabled = val;
    },
    handleLoading(val) {
      this.loading = val;
    },
    handleGetFormula(val) {
      this.Formula = val;
    },
    handleSaveAndReturn() {
      this.saveReturn = true;
    },
    handleSave() {
      this.loading = false;
      this.saveReturn = false;
    },
    handleItems(val) {
      this.items = val;
    },
    handleGetItems() {
      this.refresh = true;
      this.initialLoading = false;
    },
    handleChange() {
      this.refresh = false;
    },
    handleDialog() {
      this.openDialog = true;
    },
    handleDialogSeverance() {
      this.openDialogSeveranc = true;
    },
    handleCloseDialog() {
      this.openDialog = false;
      this.openDialogSeveranc = false;
    },
    handleClose() {
      this.calc = false;
    },
    handleCalcDialog(val) {
      this.calc = true;
      this.rowData = val.configs;
      this.calcYear = val.year || null;
      this.calcMonth = val.month || null;
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
}
.table-wrapper {
  position: relative;
  min-height: 300px;
}
</style>
